import React from 'react';
import PropTypes from 'prop-types';
import {GlossaryErrorState} from '@learningblocks/shared-components';
import {GlossaryDetailsLoader} from '@learningblocks/shared-components';
import style from './style.module.scss';

export function DetailsBlock(props) {
  if (props.loading === false && props.error === false) {
    return props.children;
  } else if (props.error) {
    return <DetailsBlockError onRetry={props.onRetry} />;
  } else {
    return <GlossaryDetailsLoader />;
  }
}

DetailsBlock.propTypes = {
  /**
   * Props of chid components for block.
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element])
    .isRequired,
  /**
   * Prop if list is loading
   */
  loading: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.bool]),
  /**
   * Prop if fetchingApi returned error
   */
  error: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.bool]),
  /**
   * Function executed when retry button is clicked on error state
   */
  onRetry: PropTypes.func.isRequired,
};

DetailsBlock.defaultProps = {
  loading: null,
  error: null,
};

/**
 * DetailsBlockError
 *  - Display Error message when details api fails
 */
function DetailsBlockError({onRetry}) {
  return (
    <GlossaryErrorState
      onRetry={onRetry}
      className={style.glossaryDetailsErrorBlock}
    />
  );
}

DetailsBlockError.propTypes = {
  /**
   * Callback function to execute when retry button is clicked
   */
  onRetry: PropTypes.func.isRequired,
};
